var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "xingfang-baobei-share" }, [
    _vm.$route.query.type == "share"
      ? _c("div", { staticClass: "success" }, [
          _c("div", { staticClass: "title" }, [_vm._v("报备成功")]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "btn-share",
              on: {
                click: function ($event) {
                  _vm.showShareCover = true
                },
              },
            },
            [_vm._v("立即分享")]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.$route.query.type == "result"
      ? _c("div", { staticClass: "result" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "lable" }, [_vm._v("项目名称：")]),
            _vm._v(" "),
            _c("span", { staticClass: "content" }, [
              _vm._v(_vm._s(_vm.$route.query.xmmc)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "lable" }, [_vm._v("客户姓名：")]),
            _vm._v(" "),
            _c("span", { staticClass: "content" }, [
              _vm._v(_vm._s(_vm.$route.query.khmc)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "lable" }, [_vm._v("联系电话：")]),
            _vm._v(" "),
            _c("span", { staticClass: "content" }, [
              _vm._v(_vm._s(_vm.$route.query.khdh)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "lable" }, [_vm._v("经纪人区域/门店：")]),
            _vm._v(" "),
            _c("span", { staticClass: "content" }, [
              _vm._v(_vm._s(_vm.$route.query.jjrqy)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "lable" }, [_vm._v("经纪人姓名：")]),
            _vm._v(" "),
            _c("span", { staticClass: "content" }, [
              _vm._v(_vm._s(_vm.$route.query.jjrxm)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "lable" }, [_vm._v("经纪人电话：")]),
            _vm._v(" "),
            _c("span", { staticClass: "content" }, [
              _vm._v(_vm._s(_vm.$route.query.jjrdh)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "lable" }, [_vm._v("预计到访时间：")]),
            _vm._v(" "),
            _c("span", { staticClass: "content" }, [
              _vm._v(_vm._s(_vm.$route.query.dfsj)),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.showShareCover
      ? _c(
          "div",
          {
            staticClass: "share-cover",
            on: {
              click: function ($event) {
                _vm.showShareCover = false
              },
            },
          },
          [_c("img", { attrs: { src: require("../../images/share-it.png") } })]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item" }, [
      _c("span", { staticClass: "lable" }, [_vm._v("渠道公司：")]),
      _vm._v(" "),
      _c("span", { staticClass: "content" }, [_vm._v("京西找房")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }